"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));

var _default = (0, _createSvgIcon.default)( /*#__PURE__*/_react.default.createElement("path", {
  d: "M12 24A12 12 0 1 0 0 12a12 12 0 0 0 12 12ZM6.79 10.29l4.5-4.5a1 1 0 0 1 1.42 0l4.5 4.5a1 1 0 1 1-1.42 1.41l-2.36-2.36a.28.28 0 0 0-.28-.06.26.26 0 0 0-.15.24V18a1 1 0 0 1-2 0V9.52a.26.26 0 0 0-.15-.24.28.28 0 0 0-.28.06L8.21 11.7a1 1 0 1 1-1.42-1.41Z"
}), 'NavigationUpCircle');

exports.default = _default;